import(/* webpackMode: "eager" */ "/workspace/app/page.tsx");
